<template>
  <div class="search">
    <i-row>
      <i-col class="search_contents">
        <div class="search_contents__item search__basic_display">
          基本表示設定：
          <CheckboxBtn label="成約非表示" :value.sync="search.contracted" />
          <span style="margin: 0 8px;">確認日:</span>
          <InputDatePicker
            :from.sync="search.vacancy_sort_from"
            :to.sync="search.vacancy_sort_to"
            :confirm="true"
          />日の範囲で表示する
        </div>
        <i-button
          class="search_contents__item"
          type="primary"
          size="small"
          icon="md-add-circle"
          @click="onClickSearchDrawer"
        >
          詳細条件
        </i-button>
        <i-button class="search_contents__item" type="primary" size="small" icon="ios-bookmark" @click="onClickSearchList">保存した検索条件</i-button>
      </i-col>
    </i-row>
    <i-row>
      <i-col class="search_contents">
        <div class="search_contents__item search__basic_detail">
          <i-button type="primary" size="small" icon="ios-map" @click="onClickSearchArea">
            住所から探す
          </i-button>
          <span style="margin: 0 4px;">または</span>
          <i-button type="primary" size="small" icon="ios-train" @click="onClickSearchRailway">
            沿線から探す
          </i-button>
        </div>
        <i-input
          v-model="search.id"
          size="small"
          placeholder="物件ID(スペース区切りでor検索)"
          @on-enter="onSearch()"
          class="search_contents__item"
          style="width: 190px;"
        />
        <i-input
          v-model="search.control_no"
          size="small"
          placeholder="物件管理番号"
          @on-enter="onSearch()"
          class="search_contents__item"
          style="width: 120px;"
        />
        <i-input
          v-model="search.property_name"
          size="small"
          placeholder="物件名もしくはカナ"
          @on-enter="onSearch()"
          class="search_contents__item"
          style="width: 150px;"
        />
        <CheckboxBtn label="一時保存のみ" :value.sync="search.tmp_save" class="search_contents__item" />
        <i-button
          type="primary"
          size="small"
          icon="ios-search-outline"
          @click="onSearch()"
          class="search_contents__item btn-search"
        >
          検索
        </i-button>
        <i-button
          type="primary"
          size="small"
          icon="ios-refresh"
          ghost
          @click="onClickSearchReset()"
          class="search_contents__item"
        >
          検索リセット
        </i-button>
      </i-col>
    </i-row>
  </div>
</template>

<script>
import { Row, Col, Input, Button } from 'view-design'
import CheckboxBtn from '@/components/parts/CheckboxBtn'
import InputDatePicker from '@/components/parts/InputDatePicker'
export default {
  components: {
    'i-row': Row,
    'i-col': Col,
    'i-input': Input,
    'i-button': Button,
    CheckboxBtn,
    InputDatePicker,
  },
  data() {
    return {}
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
  },
  methods: {
    onSearch() {
      this.$emit('search')
    },
    onClickSearchReset() {
      this.$emit('searchReset')
    },
    // 詳細条件ボタン クリック処理
    onClickSearchDrawer() {
      this.$emit('openSearchDrawer')
    },
    // 住所から探すボタン クリック処理
    onClickSearchArea() {
      this.$store.commit('ModalSearchByArea/setModal', true)
    },
    // 沿線から探すボタン クリック処理
    onClickSearchRailway() {
      this.$store.commit('ModalSearchByRailway/setModal', true)
    },
    // 保存した検索条件ボタン クリック処理
    onClickSearchList() {
      this.$store.commit('ModalSearchConditions/setModal', true)
    },
    // 日付フォーマット
    formatDate(date) {
      let format = 'yyyy-MM-dd'
      format = format.replace(/yyyy/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3))
      return format
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  &_contents {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: -8px;
    &__item {
      margin-bottom: 8px;
      margin-right: 4px;
    }
  }
  &__basic_display {
    margin-right: 8px;
    padding: 4px 8px;
    background-color: #fff;
    display: inline-block;
  }
  &__basic_detail {
    display: inline-block;
    padding: 4px;
    border: 1px solid #cfcfcf;
    border-radius: 4px;
    text-align: center;
    background-color: #f0f0f0;
  }
}
</style>

<style lang="scss">
.search {
  .ivu-row {
    margin-bottom: 8px;
  }
  .btn-search {
    margin-right: 4px;
    padding-left: 16px;
    padding-right: 16px;
    &.ivu-btn-primary {
      color: #fff;
      background-color: #da81b2;
      border-color: #da81b2;
      &:hover {
        background-color: #ea9aba;
        border-color: #ea9aba;
      }
    }
    .ivu-icon {
      padding-right: 2px;
    }
  }
}
</style>
